import { Outlet } from "react-router-dom";
import SidebarMitra from "../sidebarMitra/Sidebar";
import "./style.scss";

const AppLayoutMitra = () => {
    return <div className="lay">
        <SidebarMitra />
        <Outlet />
    </div>;
};

export default AppLayoutMitra;
